import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e193434"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "address-form" }

import { t } from '@/plugins/i18n'
import { ElMessage, FormInstance } from 'element-plus'
import { ref, toRaw, watch, computed } from 'vue'
import { cloneDeep } from 'lodash'
import { setDefaultForm } from '@/util/common'
import { updateShopCartAddressApi } from '@/apis/shopcart'
import useRules, { useMust, useRule } from '@/util/useRules'
import CommonDialog from '@/components/common/CommonDialog.vue'
import SortSelect from '@/components/common/SortSelect.vue'
import { getAddressCodeName, getTotalCountryList, getAreaList } from '@/util/useCountry'
import { useSite2Station, isJA, isKO, useSite2Code, getWarehouseCode } from '@/store'
import { getExpressAllCountryListApi } from '@/apis/user'

export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: ''
  },
  form: {
    type: Object,
    default: () => ({})
  },
  platformOrderNo: {
    type: String,
    default: ''
  },
  countryList: {
    type: Array,
    default: () => []
  }
},
  emits: ['update:visible', 'success'],
  setup(__props, { emit: emits }) {

const props = __props

const show = computed(() => props.visible)


const defaultForm = {
  receiveName: '',
  country: '',
  postalCode: '',
  receiveTel: '',
  province: '',
  city: '',
  address: '',
  countryJp: '',
  provinceJp: '',
  cityJp: ''
}

const getName = (code: string) => {
  if (code === 'JP' && isJA()) {
    return 'nameJa'
  }
  if (code === 'KR' && isKO()) {
    return 'nameKr'
  }
  return 'nameEn'
}
const rules = computed(() => {
  clearFomValidate()
  return {
    country: { message: t('国家不能为空'), required: true },
    receiveName: useRules({ message: t('收件人姓名不能为空'), key: 'deliver' }),
    province: useMust(t('都道府县不能为空'), 'change'),
    city: _form.value.countryCode === 'US' ? useMust(t('市不能为空'), 'change') : undefined,
    address: useRules({ message: t('详细地址不能为空'), key: _form.value.country === '2115' ? 'address40' : 'address' }),
    receiveTel: useRules({ message: t('联系电话不能为空'), key: 'apiPhone' }),
    postalCode: useRules({ message: t('邮编不能为空'), key: _form.value.country === '2279' ? 'postal' : 'postalCode' })
  }
})

const getForm = (form: any) => setDefaultForm(cloneDeep(toRaw(form)), defaultForm)
const phoneCode = ref('')
const _form = ref(getForm(props.form))
const submitLoading = ref(false)
const submit = () => {
  if (!addressRef.value) return
  addressRef.value.validate(async (valid) => {
    if (valid) {
      submitLoading.value = true
      const countryInfo = await getAddressCodeName({
        area: _form.value.province,
        city: _form.value.city,
        countryCode: (props.countryList as any).find((v: { intAreaId: string }) => v.intAreaId === _form.value.country)?.code
      })
      const { success } = await updateShopCartAddressApi({
        ..._form.value,
        countryCode: countryInfo.countryCode,
        countryJp: countryInfo.countryItem.nameJa ?? countryInfo.countryItem[getName(countryInfo.countryCode)],
        provinceJp: countryInfo.areaItem.nameJa ?? countryInfo.areaItem[getName(countryInfo.countryCode)],
        cityJp: countryInfo.cityItem.nameJa ?? countryInfo.cityItem[getName(countryInfo.countryCode)] ?? ''
      })
      submitLoading.value = false
      if (success) {
        ElMessage.success(t('保存成功'))
        emits('update:visible', false)
        setTimeout(() => {
          emits('success')
        }, 500)
      }
    } else {
      return false
    }
  })
}
const cities: any = ref([])

const addressRef = ref<FormInstance>()
const krCountryId = ref('')
watch(() => props.visible, async (newValue) => {
  if (newValue) {
    const totalCountry: any = await getTotalCountryList()
    krCountryId.value = totalCountry.find((i) => i.code === 'KR')?.intAreaId ?? ''
    if (!props.form?.id) {
      // 先展示默认国家
      const countryItem: any = props.countryList.find((k: any) => k.code === useSite2Code()) ?? {}
      if (!countryItem.intAreaId) return
      _form.value.country = countryItem.intAreaId
      phoneCode.value = `+${countryItem.areaNum}`
      changeCountry(countryItem)
    } else {
      const countryInfo = await getAddressCodeName({
        area: props.form?.province,
        city: props.form?.city,
        countryCode: props.form?.countryCode
      })
      provinces.value = countryInfo.areaList ?? []
      cities.value = countryInfo.cityList ?? []
      phoneCode.value = `+${countryInfo?.countryItem?.areaNum}`
    }
  }
}, {
  immediate: true
})

const provinces = ref([])
// 修改国家时重置省市
const changeCountry = (item: any) => {
  getAreaList(item).then((res: any) => {
    _form.value.province = res && res.length === 0 ? '-' : ''
    _form.value.city = ''
    _form.value.address = ''
    _form.value.postalCode = ''
    phoneCode.value = '+' + item.areaNum
    provinces.value = res
    cities.value = []
    _form.value.countryCode = item.code
    clearFomValidate()
  })
}
const changeArea = (item: any) => {
  console.log(item)
  _form.value.city = ''
  _form.value.cityJp = ''
  getAreaList(item).then((res: any) => {
    cities.value = res
  })
}
const clearFomValidate = () => {
  setTimeout(() => {
    addressRef.value && addressRef.value.clearValidate(['province', 'city', 'address', 'postalCode', 'receiveName', 'receiveTel'])
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(CommonDialog, {
    "model-value": _unref(show),
    onCancel: _cache[7] || (_cache[7] = ($event: any) => (emits('update:visible', false))),
    draggable: "",
    className: "address-dialog",
    title: __props.title,
    footer: true,
    loading: submitLoading.value,
    cancelText: _unref(t)('取消'),
    okText: _unref(t)('确认'),
    onOk: submit
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_form, {
          ref: (_value, _refs) => {
            _refs['addressRef'] = _value
            addressRef.value = _value
          },
          rules: _unref(rules),
          model: _form.value,
          "label-width": "138px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _unref(t)('国/地区'),
              prop: "country"
            }, {
              default: _withCtx(() => [
                _createVNode(SortSelect, {
                  value: _form.value.country,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_form.value.country) = $event)),
                  onChange: changeCountry,
                  list: __props.countryList,
                  type: "country",
                  rowKey: "intAreaId",
                  width: 400
                }, null, 8, ["value", "list"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('收件人'),
              prop: "receiveName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _form.value.receiveName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_form.value.receiveName) = $event)),
                  style: {"width":"400px"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('电话'),
              prop: "receiveTel"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _form.value.receiveTel,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_form.value.receiveTel) = $event)),
                  style: {"width":"400px"}
                }, {
                  prepend: _withCtx(() => [
                    _createTextVNode(_toDisplayString(phoneCode.value || '-'), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _form.value.country === '2279' ? _unref(t)('都道府县') : _unref(t)('都道府県/州/地域'),
              prop: "province"
            }, {
              default: _withCtx(() => [
                _createVNode(SortSelect, {
                  value: _form.value.province,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_form.value.province) = $event)),
                  onChange: changeArea,
                  list: provinces.value,
                  type: "area",
                  rowKey: "intAreaId",
                  width: 400,
                  country: _form.value.country
                }, null, 8, ["value", "list", "country"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('市区町村'),
              prop: "city"
            }, {
              default: _withCtx(() => [
                _createVNode(SortSelect, {
                  value: _form.value.city,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_form.value.city) = $event)),
                  list: cities.value,
                  type: "area",
                  rowKey: "intAreaId",
                  width: 400,
                  country: _form.value.country,
                  disabled: krCountryId.value === _form.value.country
                }, null, 8, ["value", "list", "country", "disabled"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('区町村-详细地址'),
              prop: "address"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  maxlength: 100,
                  modelValue: _form.value.address,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_form.value.address) = $event)),
                  style: {"width":"400px"},
                  type: "textarea"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('邮编'),
              prop: "postalCode"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _form.value.postalCode,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_form.value.postalCode) = $event)),
                  style: {"width":"400px"},
                  maxlength: 20
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["rules", "model"])
      ])
    ]),
    _: 1
  }, 8, ["model-value", "title", "loading", "cancelText", "okText"]))
}
}

})